import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

export type SandboxCostReference = {
  status: string;
  hourly_usd: string | null;
  node_hourly_usd?: string | null;
  price_stale?: boolean;
  price_version?: string | null;
  price_catalog_key?: string | null;
  allocation?: { allocated_hourly_usd: string; unused_hourly_usd: string };
  node_price?: { sku: string; rate_code: string; observed_ms: number };
  meaning?: string;
};

function dollars(value: string) {
  const [whole, fraction = ""] = value.split(".");
  return `USD ${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.${fraction.replace(/0+$/, "").padEnd(2, "0")}`;
}

export function SandboxReferencePrice({ estimate, showNodeQuote = false }: { estimate?: SandboxCostReference; showNodeQuote?: boolean }) {
  const { t } = useI18n();
  const reason = ({
    pending: t("费用正在后台计算", "Cost calculation pending"),
    stale: t("费用结果已过期，等待更新", "Cost estimate expired; awaiting refresh"),
    price_unavailable: t("无本地节点报价", "No local node quote"),
    price_model_unsupported: t("此节点没有适用的报价模型", "No applicable price model for this node"),
    price_configuration_mismatch: t("报价与节点规格不匹配", "Quote does not match the node configuration"),
    instance_unmapped: t("尚未关联 EC2 节点", "EC2 node not linked"),
    node_usage_incomplete: t("节点用量不完整，暂不能分摊", "Node usage incomplete; allocation unavailable"),
    node_inventory_too_large: t("节点清单超出读取上限", "Node inventory exceeds the read limit"),
    price_inputs_invalid: t("报价或节点计量数据无效", "Invalid quote or node measurements"),
    not_in_current_inventory: t("已结束或不在当前清单，不估算当前费用", "Ended or absent from inventory; no current estimate"),
  } as Record<string, string>)[estimate?.status ?? ""] ?? t("费用数据暂不可用", "Cost data unavailable");
  return <div className="sandbox-reference-price">
    <strong>{estimate?.hourly_usd != null ? dollars(estimate.hourly_usd) : t("暂不可算", "Unavailable")}</strong>
    {estimate?.hourly_usd == null ? <small>{reason}</small> : <small>{t("共享节点分摊参考", "Shared-node allocation reference")}</small>}
    {showNodeQuote && estimate?.node_hourly_usd != null ? <small>{t("整节点报价", "Whole-node quote")}: {dollars(estimate.node_hourly_usd)} / h</small> : null}
    {estimate?.price_stale ? <small>{t("使用最近成功取得的过期报价", "Using the last successful, stale quote")}</small> : null}
    {estimate?.price_catalog_key && estimate.price_version ? <Link to={`/billing/prices/${estimate.price_catalog_key}`} title={estimate.price_version}>{t("报价版本", "Quote version")} {estimate.price_version.slice(0, 10)}</Link> : null}
  </div>;
}
